export default __webpack_public_path__ + "static/media/notifications.cce2e1a3.svg";